import {
  Autocomplete,
  Box,
  Button,
  Grid,
  IconButton,
  Paper,
  TextField,
  Tooltip,
  Typography,
} from "@mui/material";
import {
  Cancel,
  Visibility,
  KeyboardReturn,
  Update,
} from "@mui/icons-material";
import { DataGrid } from "@mui/x-data-grid";
import SaveIcon from "@mui/icons-material/Save";
import RemoveCircleOutlineIcon from "@mui/icons-material/RemoveCircleOutline";
import EditOutlinedIcon from "@mui/icons-material/EditOutlined";
import AddCircleOutlineIcon from "@mui/icons-material/AddCircleOutline";
import { v4 as uuidv4 } from "uuid";
import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { useParams } from "react-router-dom";
import { getCacheData } from "../../services/CacheService";
import { getBlockCristal, saveBlockCristal } from "../../services/BlockCristalService";
import Message from "../../utils/Message";
import WaitingDialog from "../../utils/WaitingDialog";
import IngresoCristalDialog from "./IngresoCristalDialog";

const initialState = {
  id: null,
  idCristalProducto: null,
  idBlCrDiametro: null,
  idBlCrAdicion: null,
  idBlCurva: null,
  idBlEspesor: null,
  idBlCrOjo: null,
  observaciones: "",
};

const ojoOptions = [
  {
    id: "izquierdo",
    label: "IZQUIERDO"
  },
  {
    id: "derecho",
    label: "DERECHO"
  },
  {
    id: "indistinto",
    label: "INDISTINTO"
  },
];
const nameItemsText = "Block-Cristal";
//
// #############################################################################
//
const BlockCristal = () => {
  const params = useParams();
  const navigate = useNavigate();
  const _idBlCristal = params.idBlCristal;
  const _action = params.action;
  const [itemCrudLocal, setItemCrudLocal] = useState(initialState);
  const [isDoingSomething, setIsDoingSomething] = useState(false);
  const [openIngresoCristalDialog, setOpenIngresoCristalDialog] = useState(false);
  const [cristalesList, setCristalesList] = useState([]);
  const [isSaving, setIsSaving] = useState(false);
  const [actionCrud, setActionCrud] = useState("");
  const [actionCristalDialog, setActionCristalDialog] = useState("");
  const [itemCrud, setItemCrud] = useState(initialState);
  const [showMessage, setShowMessage] = useState(false);
  const [message, setMessage] = useState({
    messageText: "",
    severity: "",
  });
  const [titleComponent, setTitleComponent] = useState("");
  const [blProductos, setBlProductos] = useState([]);
  const [blCrAdiciones, setBlCrAdiciones] = useState([]);
  const [blCurvas, setBlCurvas] = useState([]);
  const [blEspesores, setBlEspesores] = useState([]);
  const [btnSave, setBtnSave] = useState(false);
  const [valueACBlProducto, setValueACBlProducto] = useState({
    id: "",
    descripcion: "",
  });
  const [inputvalueACBlProducto, setInputvalueACBlProducto] = useState("");
  const [valueACBlCrAdicion, setValueACBlCrAdicion] = useState({
    id: "",
    descripcion: "",
  });
  const [inputValueACBlCrAdicion, setInputValueACBlCrAdicion] = useState("");
  const [valueACBlCurva, setValueACBlCurva] = useState({
    id: "",
    descripcion: "",
  });
  const [inputValueACBlCurva, setInputValueACBlCurva] = useState("");
  const [valueACBlEspesor, setValueACBlEspesor] = useState({
    id: "",
    descripcion: "",
  });
  const [inputValueACBlEspesor, setInputValueACBlEspesor] = useState("");
  const [valueACOjo, setValueACOjo] = useState({
    id: "",
    descripcion: "",
  });
  const [inputValueACOjo, setInputValueACOjo] = useState("");

  const tableColumnsCristalesList = [
    {
      field: "descripcion_cristal_producto",
      headerName: "Producto",
      flex: 1,
      minWidth: 200,
      sortable: false,
      renderCell: (params) => (
        <span style={{ fontSize: "0.9em" }}>
          {params.row.descripcion_cristal_producto ? params.row.descripcion_cristal_producto.toUpperCase() : ""}
        </span>
      ),
    },
    {
      field: "ojo",
      headerName: "Ojo",
      width: 120,
      sortable: false,
      headerAlign: "center",
      align: "center",
      renderCell: (params) => (
        <span style={{ fontSize: "0.9em" }}>
          {params.row.ojo ? params.row.ojo.toUpperCase() : ""}
        </span>
      ),
    },
    {
      field: "actions",
      headerName: "Acciones",
      width: 180,
      sortable: false,
      filterable: false,
      headerAlign: "center",
      align: "center",
      renderCell: (params) => (
        <>
          {(actionCrud === "update" || actionCrud === "new") && (
            <Tooltip title="Editar Cristal">
              <IconButton
                size="small"
                aria-label="edit"
                onClick={() => handleClickCristal(params.row, "update")}
              >
                <EditOutlinedIcon />
              </IconButton>
            </Tooltip>
          )}
          {(actionCrud === "update" || actionCrud === "new") && (
            <Tooltip title="Quitar Cristal">
              <IconButton
                size="small"
                aria-label="delete"
                onClick={() => handleClickCristal(params.row, "delete")}
              >
                <RemoveCircleOutlineIcon />
              </IconButton>
            </Tooltip>
          )}
          {(actionCrud === "enable" || actionCrud === "disable") && (
            <Tooltip title="Ver Cristal">
              <IconButton
                size="small"
                aria-label="view"
                onClick={() => handleClickCristal(params.row, "view")}
              >
                <Visibility />
              </IconButton>
            </Tooltip>
          )}
        </>
      ),
    },
  ];

  const tableOptionsCristalesList = {
    disableColumnMenu: true,
    disableColumnFilter: true,
    disableColumnSelector: true,
    disableDensitySelector: true,
    disableRowSelectionOnClick: true,
    //loading: isDoingSomething,
    getRowId: (row) => row._gridId || row.id || `${row.id_cristal_producto}-${row.ojo}`,
    hideFooter: true,
    localeText: {
      noRowsLabel: "",
    },
    sx: {
      '& .MuiDataGrid-cell': {
        fontSize: '0.9em',
      },
      '& .MuiDataGrid-columnHeaders': {
        backgroundColor: '#f5f5f5',
      },
    },
  };
  //
  // ##########################################################################
  //
  useEffect(() => {
    setActionCrud(_action);
    loadBlProductos();
    loadBlCurvas();
    loadBlCrAdiciones();
    loadBlEspesores();

    if (_action === "new") {
      setTitleComponent("Nuevo " + nameItemsText);
    } else {
      setActionCrud(_action);
      load();
    }
  }, []);
  //
  // ##########################################################################
  //
  useEffect(() => {
    if (cristalesList.length > 0 &&
      valueACBlProducto.id !== "" &&
      valueACBlProducto.id !== null &&
      valueACBlProducto.id !== undefined &&
      valueACBlCrAdicion.id !== "" &&
      valueACBlCrAdicion.id !== null &&
      valueACBlCrAdicion.id !== undefined &&
      valueACBlCurva.id !== "" &&
      valueACBlCurva.id !== null &&
      valueACBlCurva.id !== undefined &&
      valueACOjo.id !== "" && valueACOjo.id !== null && valueACOjo.id !== undefined) {
      setBtnSave(true);
    } else {
      setBtnSave(false);
    }
  }, [cristalesList, valueACBlProducto, valueACBlCrAdicion, valueACBlCurva, valueACOjo]);


  //
  // ##########################################################################
  //
  const handleCancelar = () => {
    navigate("/bl-cristal-table");
  };
  //
  // ##########################################################################
  //
  const handleChange = (e) => {
    setItemCrudLocal({
      ...itemCrudLocal,
      [e.target.name]: e.target.value,
    });
  };
  //
  // ##########################################################################
  //
  const handleClickCristal = (row, action) => {
    const _itemCrud = action === "new"
      ? {} // agregar nuevo: itemCrud vacío para que handleOnSaveCristal sepa que es create
      : {
        idCristalProducto: row.id_cristal_producto,
        descripcionCristalProducto: row.descripcion_cristal_producto ? row.descripcion_cristal_producto.toUpperCase() : "",
        adicionesList: row.adiciones_list,
        diametrosList: row.diametros_list,
        rangosList: row.rangos_list,
        observaciones: row.observaciones ? row.observaciones.toUpperCase() : "",
        ojo: row.ojo,
      };
    setActionCristalDialog(action);
    setItemCrud(_itemCrud);
    setOpenIngresoCristalDialog(true);
  };
  //
  // ##########################################################################
  //
  const handleSave = async (parAction) => {
    let object = {};
    if (
      valueACBlProducto.id === "" ||
      valueACBlProducto.id === null ||
      valueACBlProducto.id === undefined
    ) {
      setMessage({
        messageText: "Debes seleccionar el Producto",
        severity: "error",
      });
      setShowMessage(true);
      return;
    }

    if (
      valueACBlCrAdicion.id === "" ||
      valueACBlCrAdicion.id === null ||
      valueACBlCrAdicion.id === undefined
    ) {
      setMessage({
        messageText: "Debes seleccionar la Adición",
        severity: "error",
      });
      setShowMessage(true);
      return;
    }

    if (
      valueACBlCurva.id === "" ||
      valueACBlCurva.id === null ||
      valueACBlCurva.id === undefined
    ) {
      setMessage({
        messageText: "Debes seleccionar la Curva",
        severity: "error",
      });
      setShowMessage(true);
      return;
    }

    if (
      valueACOjo.id === "" ||
      valueACOjo.id === null ||
      valueACOjo.id === undefined
    ) {
      setMessage({
        messageText: "Debes seleccionar Ojo",
        severity: "error",
      });
      setShowMessage(true);
      return;
    }
    // pregunto si se ha cargado al menos un cristal sinó devuelvo error
    if (cristalesList.length === 0) {
      setMessage({
        messageText: "Debes seleccionar al menos un Cristal",
        severity: "error",
      });
      setShowMessage(true);
      return;
    }

    if (parAction === "update") {
      object.id = itemCrudLocal.id;
    }

    object = {
      id: itemCrudLocal.id,
      idBlockProducto: valueACBlProducto.id,
      idBlCrAdicion: valueACBlCrAdicion.id,
      idBlCurva: valueACBlCurva.id,
      idBlEspesor: valueACBlEspesor.id,
      ojo: valueACOjo.id,
      cristalesList: cristalesList.map(c => ({
        id_cristal_producto: c.id_cristal_producto,
        ojo: c.ojo,
        adiciones_list: c.adiciones_list.map(a => ({
          id_bl_cr_adicion: a.id_bl_cr_adicion,
        })),
        diametros_list: c.diametros_list.map(d => ({
          id_bl_cr_diametro: d.id_bl_cr_diametro,
        })),
        rangos_list: c.rangos_list.map(r => ({
          esfera_desde: r.esfera_desde,
          esfera_hasta: r.esfera_hasta,
          cilindro_desde: r.cilindro_desde,
          cilindro_hasta: r.cilindro_hasta,
        })),
        observaciones: c.observaciones,
      })),
      observaciones: itemCrudLocal.observaciones.toUpperCase(),
    }

    setIsDoingSomething(true);
    const response = await saveBlockCristal(parAction, object);
    setIsDoingSomething(false);

    if (response.ok) {
      setIsSaving(true);
      setMessage({
        messageText: "El Block-Cristal ha sido guardado con éxito",
        severity: "success",
      });
      setShowMessage(true);
      setTimeout(() => {
        navigate("/bl-cristal-table");
      }, 500);

      // return;
    } else {
      setMessage({
        messageText: response.messageText,
        severity: response.messageSeverity,
      });
      setShowMessage(true);
    }
  };
  //
  // ################################################################################
  //
  const load = async () => {

    setIsDoingSomething(true);
    const response = await getBlockCristal({ id: _idBlCristal });
    setIsDoingSomething(false);

    if (response.ok) {

      let _response = response.data.data;

      if (_action === "update") {
        setTitleComponent("Editando " + nameItemsText);
      } else if (_action === "disable") {
        setTitleComponent("Deshabilitando " + nameItemsText);
      } else if (_action === "enable") {
        setTitleComponent("Habilitando " + nameItemsText);
      }

      setValueACBlProducto({
        id: _response.id_block_producto,
        label: _response.descripcion_block_producto,
      });
      setValueACBlCrAdicion({
        id: _response.id_bl_cr_adicion,
        // cuando el valor es 0, se debe mostrar como 0.00
        label: _response.valor_bl_cr_adicion === 0 ? "0.00" : _response.valor_bl_cr_adicion?.toFixed(2)
      });
      setValueACBlCurva({
        id: _response.id_bl_curva,
        label: _response.valor_bl_curva === 0 ? "0" : _response.valor_bl_curva?.toFixed(0)
      });
      setValueACBlEspesor({
        id: _response.id_bl_espesor,
        label: _response.valor_bl_espesor ? _response.valor_bl_espesor?.toFixed(0) : "",
      });
      setValueACOjo({
        id: _response.ojo,
        label: _response.ojo ? _response.ojo.toUpperCase() : "",
      });
      setCristalesList((Array.isArray(_response.cristales_list) ? _response.cristales_list : []).map((c, i) => ({
        ...c,
        _gridId: c._gridId || c.id || `${c.id_cristal_producto}-${c.ojo}-${i}`,
      })));
      setItemCrudLocal(_response);
    } else {
      setMessage({
        messageText: response.messageText,
        severity: response.messageSeverity,
      });
      setShowMessage(true);
    }
  }
  //
  // ################################################################################
  //
  const loadBlProductos = async () => {
    const response = await getCacheData("block_producto")
    if (response.ok) {
      let _response = response.data.data;
      let _var = [];
      _response.forEach((item) => {
        _var.push({
          id: item.id,
          label: item.descripcion,
        });
      });
      setBlProductos(_var);
    } else {
      setBlProductos([]);
      setMessage({
        messageText: response.messageText,
        severity: response.messageSeverity,
      });
      setShowMessage(true);
    }
  };
  //
  // ################################################################################
  //
  const loadBlCrAdiciones = async () => {
    const response = await getCacheData("bl_cr_adicion")
    if (response.ok) {
      let _response = response.data.data;
      let _var = [];
      _response.forEach((item) => {
        _var.push({
          id: item.id,
          label: item.valor.toFixed(2),
        });
      });
      setBlCrAdiciones(_var);
    } else {
      setBlCrAdiciones([]);
      setMessage({
        messageText: response.messageText,
        severity: response.messageSeverity,
      });
      setShowMessage(true);
    }
  };
  //
  // ################################################################################
  //
  const loadBlCurvas = async () => {
    const response = await getCacheData("bl_curva")
    if (response.ok) {
      let _response = response.data.data;
      let _var = [];
      _response.forEach((item) => {
        _var.push({
          id: item.id,
          label: item.valor.toFixed(2),
        });
      });
      setBlCurvas(_var);
    } else {
      setBlCurvas([]);
      setMessage({
        messageText: response.messageText,
        severity: response.messageSeverity,
      });
      setShowMessage(true);
    }
  };
  //
  // ################################################################################
  //
  const loadBlEspesores = async () => {
    const response = await getCacheData("bl_espesor");
    if (response.ok) {
      let _response = response.data.data;
      let _var = [];
      _response.forEach((item) => {
        _var.push({
          id: item.id,
          label: item.valor.toFixed(0),
        });
      });
      setBlEspesores(_var);
    } else {
      setBlEspesores([]);
      setMessage({
        messageText: response.messageText,
        severity: response.messageSeverity,
      });
      setShowMessage(true);
    }
  };
  //
  // ################################################################################
  //
  const handleCloseCristal = () => {
    setOpenIngresoCristalDialog(false);
  }
  //
  // ################################################################################
  //
  const handleOnSaveCristal = (item, action) => {

    if (action === "delete") {
      // busco el cristal por su idCristalProducto y ojo para quitarlo de la lista
      const _varList = (cristalesList || []).filter(
        (cristal) => !(cristal.id_cristal_producto === item.idCristalProducto && cristal.ojo === item.ojo)
      );
      setCristalesList(_varList);
      setMessage({
        messageText: "El Cristal se ha eliminado correctamente",
        severity: "success",
      });
      setShowMessage(true);
      setOpenIngresoCristalDialog(false);
      return;
    }

    // normalizo el objeto que viene del diálogo a la forma usada en la tabla/estado
    const _normalized = {
      id_cristal_producto: item.idCristalProducto,
      descripcion_cristal_producto: item.descripcionCristalProducto ? item.descripcionCristalProducto.toUpperCase() : "",
      adiciones_list: item.adicionesList || [],
      diametros_list: item.diametrosList || [],
      rangos_list: item.rangosList || item.rangoList || [],
      observaciones: item.observaciones || "",
      ojo: item.ojo,
      _gridId: uuidv4(),
    };

    // Determinar create vs update SOLO por itemCrud: si tiene producto+ojo de un cristal existente
    // estamos editando; si no, agregando. Así no dependemos del param action que puede venir mal.
    const originalIdCristalProducto = itemCrud?.idCristalProducto;
    const originalOjo = itemCrud?.ojo;
    const isEditing = originalIdCristalProducto != null && originalIdCristalProducto !== "" &&
      originalOjo != null && originalOjo !== "";

    const _list = cristalesList ? [...cristalesList] : [];

    if (isEditing) {
      // Editando: buscar por producto+ojo originales y reemplazar solo ese registro
      const idx = _list.findIndex((cr) =>
        cr.id_cristal_producto === originalIdCristalProducto && cr.ojo === originalOjo
      );
      if (idx < 0) {
        // no encontrado, agregar como nuevo
        _list.push(_normalized);
      } else {
        // Validar que el nuevo (producto, ojo) no exista ya en otro cristal
        const duplicateExists = _list.some((cr, i) =>
          i !== idx && cr.id_cristal_producto === item.idCristalProducto && cr.ojo === item.ojo
        );
        if (duplicateExists) {
          setMessage({
            messageText: "El Producto para ese Ojo ya existe en la lista de cristales",
            severity: "error",
          });
          setShowMessage(true);
          return;
        }
        _list[idx] = { ..._normalized, _gridId: _list[idx]._gridId || _normalized._gridId };
      }
    } else {
      const exists = _list.some(
        (cristal) => cristal.id_cristal_producto === item.idCristalProducto && cristal.ojo === item.ojo
      );
      if (exists) {
        setMessage({
          messageText: "El Producto para ese Ojo ya ha sido registrado en la lista",
          severity: "error",
        });
        setShowMessage(true);
        return;
      }
      _list.push(_normalized);
    }
    setCristalesList(_list);
    setOpenIngresoCristalDialog(false);
  }
  //
  // ################################################################################
  //
  return (
    <>
      <Paper elevation={0} sx={{ mx: 0.5, maxWidth: "100%" }}>
        <Paper elevation={1} >
          <Box sx={{ mx: 1, px: 1, pb: 1 }}>
            <Grid container spacing={1}>
              <Grid item xs={12}>
                <Box display="flex" alignItems="center" sx={{ mt: 2 }}>
                  <Typography variant="h5" display="block" gutterBottom >
                    {titleComponent}
                  </Typography>
                </Box>
              </Grid>
            </Grid>
            <Box
              sx={{
                m: 1,
                p: 2,
                pt: 2,
                border: "1px solid LightGrey",
                borderRadius: "5px",
                backgroundColor: "primary",
              }}
              className="box-table"
            >
              <Grid container spacing={1} justifyContent="center">
                <Grid item xs={12} md={12} lg={10}>
                  <Autocomplete
                    id="id-bl-producto"
                    size="small"
                    sx={{ width: "100%", pb: 1 }}
                    value={
                      valueACBlProducto && valueACBlProducto.id
                        ? valueACBlProducto
                        : null
                    }
                    onChange={(event, newValue) => {
                      setValueACBlProducto(newValue);
                      setItemCrudLocal({
                        ...itemCrudLocal,
                        idCristalProducto: newValue ? newValue.id : "",
                      });
                    }}
                    inputValue={inputvalueACBlProducto}
                    onInputChange={(event, newInputValue) => {
                      setInputvalueACBlProducto(newInputValue);
                    }}
                    options={blProductos}
                    getOptionLabel={(option) => option.label || ""}
                    renderInput={(params) => <TextField {...params} label="Producto" />}
                    isOptionEqualToValue={(option, value) => {
                      if (!value || !value.id) return false;
                      return option.id === value.id;
                    }}
                    disableClearable={true}
                    disabled={actionCrud === "view" || actionCrud === "enable" || actionCrud === "disable"}
                  />
                </Grid>
              </Grid>

              <Grid container spacing={1} justifyContent="center">
                <Grid item xs={12} md={12} lg={2.5}>
                  <Autocomplete
                    id="id-bl-cr-adicion"
                    size="small"
                    value={
                      valueACBlCrAdicion && valueACBlCrAdicion.id
                        ? valueACBlCrAdicion
                        : null
                    }
                    onChange={(event, newValue) => {
                      setValueACBlCrAdicion(newValue);
                      setItemCrudLocal({
                        ...itemCrudLocal,
                        idBlCrAdicion: newValue ? newValue.id : "",
                      });
                    }}
                    inputValue={inputValueACBlCrAdicion}
                    onInputChange={(event, newInputValue) => {
                      setInputValueACBlCrAdicion(newInputValue);
                    }}
                    options={blCrAdiciones}
                    getOptionLabel={(option) => option.label || ""}
                    renderInput={(params) => <TextField {...params} label="Adición" />}
                    isOptionEqualToValue={(option, value) => {
                      if (!value || !value.id) return false;
                      return option.id === value.id;
                    }}
                    disableClearable={true}
                    disabled={actionCrud === "view" || actionCrud === "enable" || actionCrud === "disable"}
                  />
                </Grid>

                <Grid item xs={12} md={12} lg={2.5}>
                  <Autocomplete
                    id="id-bl-curva"
                    size="small"
                    value={
                      valueACBlCurva && valueACBlCurva.id
                        ? valueACBlCurva
                        : null
                    }
                    onChange={(event, newValue) => {
                      setValueACBlCurva(newValue);
                      setItemCrudLocal({
                        ...itemCrudLocal,
                        idBlCurva: newValue ? newValue.id : "",
                      });
                    }}
                    inputValue={inputValueACBlCurva}
                    onInputChange={(event, newInputValue) => {
                      setInputValueACBlCurva(newInputValue);
                    }}
                    options={blCurvas}
                    getOptionLabel={(option) => option.label || ""}
                    renderInput={(params) => <TextField {...params} label="Curva" />}
                    isOptionEqualToValue={(option, value) => {
                      if (!value || !value.id) return false;
                      return option.id === value.id;
                    }}
                    disableClearable={true}
                    disabled={actionCrud === "view" || actionCrud === "enable" || actionCrud === "disable"}
                  />
                </Grid>

                <Grid item xs={12} md={12} lg={2.5}>
                  <Autocomplete
                    id="id-bl-espesor"
                    size="small"
                    value={
                      valueACBlEspesor && valueACBlEspesor.id
                        ? valueACBlEspesor
                        : null
                    }
                    onChange={(event, newValue) => {
                      setValueACBlEspesor(newValue);
                      setItemCrudLocal({
                        ...itemCrudLocal,
                        idBlEspesor: newValue ? newValue.id : "",
                      });
                    }}
                    inputValue={inputValueACBlEspesor}
                    onInputChange={(event, newInputValue) => {
                      setInputValueACBlEspesor(newInputValue);
                    }}
                    options={blEspesores}
                    getOptionLabel={(option) => option.label || ""}
                    renderInput={(params) => <TextField {...params} label="Espesor" />}
                    isOptionEqualToValue={(option, value) => {
                      if (!value || !value.id) return false;
                      return option.id === value.id;
                    }}
                    disableClearable={true}
                    disabled={actionCrud === "view" || actionCrud === "enable" || actionCrud === "disable"}
                  />
                </Grid>

                <Grid item xs={12} md={12} lg={2.5}>
                  <Autocomplete
                    id="id-ojo"
                    size="small"
                    sx={{ width: "100%", mb: 1 }}
                    value={
                      valueACOjo && valueACOjo.id ? valueACOjo : null
                    }
                    onChange={(event, newValue) => {
                      setValueACOjo(newValue);
                      setItemCrudLocal({
                        ...itemCrudLocal,
                        idOjo: newValue ? newValue.id : "",
                      });
                    }}
                    inputValue={inputValueACOjo}
                    onInputChange={(event, newInputValue) => {
                      setInputValueACOjo(newInputValue);
                    }}
                    options={ojoOptions}
                    getOptionLabel={(option) => option.label}
                    renderInput={(params) => <TextField {...params} label="Seleccione Ojo " />}
                    isOptionEqualToValue={(option, value) => {
                      if (!value || !value.id) return false;
                      return option.id === value.id;
                    }}
                    disableClearable={true}
                    disabled={actionCrud === "view" || actionCrud === "enable" || actionCrud === "disable"}
                  />
                </Grid>
              </Grid>
            </Box>

            <Box
              sx={{
                m: 1,
                p: 2,
                pt: 2,
                border: "1px solid LightGrey",
                borderRadius: "5px",
                backgroundColor: "primary",
              }}
              className="box-table"
            >
              <Grid container spacing={1} >
                {(_action === "new" || _action === "update") && (
                  <Grid item xs={12} md={12} lg={2}>
                    <Tooltip title="Ingresar Cristal">
                      <span>
                        <Button
                          className="btn-add-custom"
                          variant="contained"
                          onClick={() => handleClickCristal({}, "new")}
                          size="small"
                          sx={{ mb: 1, pb: 1, mt: 1 }}
                          disabled={isSaving}
                        >
                          Cristal
                        </Button>
                      </span>
                    </Tooltip>
                  </Grid>
                )}
                <Grid item xs={12} md={12} lg={12}>
                  <Box sx={{ maxHeight: "400px", overflowY: "auto", width: "100%", marginTop: "10px" }}>
                    <Typography variant="h6" sx={{ mb: 1 }}>Cristales</Typography>
                    <DataGrid
                      rows={cristalesList}
                      columns={tableColumnsCristalesList}
                      {...tableOptionsCristalesList}
                      sx={{ width: "100%" }}
                    />
                  </Box>
                </Grid>
              </Grid>
            </Box>

            <Box
              sx={{
                m: 1,
                p: 2,
                pt: 2,
                border: "1px solid LightGrey",
                borderRadius: "5px",
                backgroundColor: "primary",
              }}
              className="box-table"
            >
              <Grid item xs={12} md={12} lg={4}>
                <TextField
                  inputProps={{
                    autoComplete: "off"
                  }}
                  id="observaciones"
                  label="Observaciones"
                  variant="outlined"
                  name="observaciones"
                  value={itemCrudLocal.observaciones}
                  onChange={handleChange}
                  multiline
                  rows={3}
                  fullWidth
                  sx={{
                    "& .MuiInputBase-root": {
                      minHeight: '80px',
                      minWidth: '400px',
                    }
                  }}
                  disabled={
                    actionCrud === "disable" || actionCrud === "enable" || actionCrud === "view" || isSaving}
                />
              </Grid>
            </Box>

            <Box
              sx={{
                m: 1,
                p: 2,
                pt: 2,
                border: "1px solid LightGrey",
                borderRadius: "5px",
                backgroundColor: "primary",
              }}
              className="box-table"
            >
              <Grid container justifyContent="flex-end" spacing={1} sx={{ mt: 0 }}>

                {_action !== "view" && (
                  <Grid item>
                    {_action === "new" && (
                      <Tooltip title="Guardar Block-Cristal">
                        <span>
                          <Button
                            variant="contained"
                            startIcon={<SaveIcon />}
                            onClick={() => handleSave("new")}
                            disabled={isSaving}
                          >
                            Guardar
                          </Button>
                        </span>
                      </Tooltip>
                    )}
                    {_action === "update" && (
                      <Tooltip title="Actualizar Block-Cristal">
                        <span>
                          <Button
                            variant="contained"
                            startIcon={<Update />}
                            onClick={() => handleSave("update")}
                            disabled={isSaving || btnSave === false}
                          >
                            Actualizar
                          </Button>
                        </span>
                      </Tooltip>
                    )}
                    {_action === "disable" && (
                      <Tooltip title="Deshabilitar la Block-Cristal">
                        <span>
                          <Button
                            variant="contained"
                            className="btn-disable"
                            size="small"
                            startIcon={<RemoveCircleOutlineIcon />}
                            onClick={() => handleSave("disable")}
                            disabled={isSaving}

                          >
                            Deshabilitar
                          </Button>
                        </span>
                      </Tooltip>
                    )}
                    {_action === "enable" && (
                      <Tooltip title="Habilitar la Block-Cristal">
                        <span>
                          <Button
                            variant="contained"
                            className="btn-enable"
                            startIcon={<AddCircleOutlineIcon />}
                            onClick={() => handleSave("enable")}
                            disabled={isSaving}

                          >
                            Habilitar
                          </Button>
                        </span>
                      </Tooltip>
                    )}
                  </Grid>
                )}
                <Grid item>
                  <Tooltip title="Volver a la Lista de Block-Cristal">
                    <span>
                      <Button
                        variant="outlined"
                        onClick={handleCancelar}
                        startIcon={_action === "view" ? <KeyboardReturn /> : <Cancel />}
                      >
                        Cancelar
                      </Button>
                    </span>
                  </Tooltip>
                </Grid>
              </Grid>
            </Box>
          </Box>
        </Paper>
      </Paper >

      {
        showMessage && (
          <Message
            showMessage={showMessage}
            setShowMessage={setShowMessage}
            message={message}
          />
        )
      }
      {
        openIngresoCristalDialog && (
          <IngresoCristalDialog
            onSave={handleOnSaveCristal}
            onClose={handleCloseCristal}
            actionCrud={actionCristalDialog || actionCrud}
            itemCrud={itemCrud}
            setMessage={setMessage}
            setShowMessage={setShowMessage}
          />
        )
      }

      <WaitingDialog open={isDoingSomething} />
    </>
  );
};
export default BlockCristal;
